<template>
    <router-view />
</template>

<style lang="scss">
@font-face {
    font-family: Merriweather;
    src: "./assets/fonts/Merriweather-Regular.ttf";
}
#app {
    font-family: Merriweather, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    scroll-behavior: smooth;
    text-align: center;
    color: #2c3e50;
}
body {
    margin: 0;
}
</style>
